<template>
  <div id="app" :style="{ backgroundColor: appBackground }">
    <div class="container" :class="{ 'wobble-hor-bottom': errorAnim }">
      <form @submit.prevent v-if="state == 'form' || state == 'switching'">
        <transition :name="stepTransition" appear mode="out-in" @after-enter="state = 'form'">
          <keep-alive>
            <step :title="$t('message.profile.stepTitle')" :key="currentIndex" v-if="currentStep == 'profile'">
              <radio
                :value="profile"
                :isDefault="userData.profile"
                @clicked="
                  userData.profile = $event;
                  delayedNext();
                "
              ></radio>
            </step>
            <step :title="$t('message.exploitation.stepTitle')" :key="currentIndex" v-if="currentStep == 'exploitation'">
              <radio
                :value="exploitation"
                :isDefault="userData.exploitation"
                @clicked="
                  userData.exploitation = $event;
                  delayedNext();
                "
              ></radio>
            </step>
            <step :title="$t('message.genre.stepTitle')" :key="currentIndex" v-if="currentStep == 'genre'">
              <radio
                :value="genre"
                :isDefault="userData.genre"
                @clicked="
                  userData.genre = $event;
                  delayedNext();
                "
              ></radio>
            </step>
            <step :title="$t('message.country')" :key="currentIndex" v-if="currentStep == 'country'">
              <select v-model="userData.country">
                <option v-for="country in apiData.common.countries" :key="country[0]" :value="country[0]">
                  {{ country[1] }}
                </option>
              </select>
            </step>
            <step :title="$t('message.broadcaster')" :key="currentIndex" v-if="currentStep == 'broadcaster'">
              <select v-model="userData.channel">
                <option v-for="(channel, index) in tvChannels" :key="index" :value="channel">
                  {{ channel }}
                </option>
              </select>
            </step>
            <step :title="$t('message.dateAndTime.stepTitle')" :key="currentIndex" v-if="currentStep == 'dateTime'" :ref="currentStep">
              <div class="row">
                <date-input v-model="userData.date" :valid="$v.userData.date" :isMobile="isMobile"></date-input>
                <transition name="fadeUp">
                  <time-input v-model="userData.time" :valid="$v.userData.time" :isMobile="isMobile"></time-input>
                </transition>
              </div>
            </step>
            <step :title="$t('message.programDuration.stepTitle')" :key="currentIndex" v-if="currentStep == 'tvDuration'" :ref="currentStep">
              <div class="tight-row">
                <num-input v-model="userData.programDuration" :valid="$v.userData.programDuration" :showError="showError">
                  <label slot="label">{{ $t('message.programDuration.programDuration')}} {{ $t('message.misc.inMinutes')}}</label>
                </num-input>
                <hr />
                <duration v-model="userData.musicDuration" @clicked="userData.tvDurationInSeconds = $event" :valid="$v.userData.musicDuration" focus="off" :isInSeconds="userData.tvDurationInSeconds" :showError="showError">
                  <label slot="label">{{ $t('message.programDuration.musicDuration')}}</label>
                </duration>
              </div>
            </step>
            <step :title="$t('message.admissions')" :key="currentIndex" v-if="currentStep == 'admissions'" :ref="currentStep">
              <num-input v-model="userData.admissions" :valid="$v.userData.admissions" :showError="showError"></num-input>
            </step>
            <step :title="$t('message.musicDuration.stepTitle')" :key="currentIndex" v-if="currentStep == 'durationStep'" :ref="currentStep">
              <div class="tight-row">
                <app-switch v-model="userData.durationInSeconds"></app-switch>
                <hr />
                <num-input v-model="userData.totalDuration" :valid="$v.userData.totalDuration" :showError="showError" :tooltipContent="$t('message.musicDuration.tooltipTotal')">
                  <label slot="label">{{ $t('message.musicDuration.total', {msg:workTitle})}}</label>
                </num-input>
                <hr />
                <num-input v-model="userData.controlledDuration" :valid="$v.userData.controlledDuration" focus="off" :showError="showError" :tooltipContent="$t('message.musicDuration.tooltipControlled')">
                  <label slot="label">{{ $t('message.musicDuration.thatYouControl')}}</label>
                </num-input>
              </div>
            </step>
            <step :title="$t('message.platform')" :key="currentIndex" v-if="currentStep == 'vStreamPlatform'">
              <select v-model="userData.vStreamingPlatform">
                <option v-for="platform in apiData.video_streaming.platforms" :key="platform" :value="platform">
                  {{ platform }}
                </option>
              </select>
            </step>
            <step :title="streamsTitle" :key="currentIndex" v-if="currentStep == 'streamsStep'" :ref="currentStep">
              <num-input v-model="userData.streams" :valid="$v.userData.streams" :showError="showError"></num-input>
            </step>
            <step :title="$t('message.platform')" :key="currentIndex" v-if="currentStep == 'mStreamPlatform'">
              <select v-model="userData.mStreamingPlatform">
                <option v-for="platform in apiData.music_streaming.platforms" :key="platform" :value="platform">
                  {{ platform }}
                </option>
              </select>
            </step>
            <step :title="$t('message.master.stepTitle')" :key="currentIndex" v-if="currentStep == 'masterOwned'">
              <radio
                :value="masterOwned"
                :isDefault="userData.masterOwned"
                @clicked="
                  userData.masterOwned = $event;
                  delayedNext();
                "
              ></radio>
            </step>
            <step :title="$t('message.lastStep.stepTitle')" :key="currentIndex" v-if="currentStep == 'finalStep'" :ref="currentStep">
              <text-input v-model="userData.workTitle" :valid="$v.userData.workTitle">
                <label slot="label">{{ $t('message.lastStep.titleProgram') }} {{ workTitle }}</label>
              </text-input>
              <text-input v-model="userData.clientName" :valid="$v.userData.clientName" focus="off" :showError="showError" :errorMessage="$t('message.validations.name')">
                <label slot="label">{{ clientName }}</label>
              </text-input>
              <text-input v-model="userData.clientEmail" :valid="$v.userData.clientEmail" focus="off" :showError="showError" :errorMessage="$t('message.validations.email')">
                <label slot="label">{{ $t('message.lastStep.emailAdress') }}</label>
              </text-input>
            </step>
          </keep-alive>
        </transition>
        <controls :state="state" :currentIndex="currentIndex" :currentStep="currentStep" :stepCount="stepList.length" @next="next" @back="back" @calculate="calculate"></controls>
      </form>
      <step :title="$t('message.calculating.stepTitle')" v-if="state == 'calculating'">
        <calculating></calculating>
      </step>
      <transition appear name="slideUp">
        <step :title="$t('message.results.stepTitle')" v-if="state == 'results'">
          <results v-if="resultsData" :wpData="wpData" :resultsData="resultsData"></results>
        </step>
      </transition>
    </div>
    <transition appear name="fade">
      <progress-bar v-if="state == 'form' || state == 'switching'" :currentVal="currentIndex" :maxVal="stepList.length"></progress-bar>
    </transition>
  </div>
</template>

<script>
import Step from "./components/Step.vue";
import SingleTextInput from "./components/SingleTextInput.vue";
import SingleNumericInput from "./components/SingleNumericInput.vue";
import SingleDuration from "./components/SingleDuration.vue";
import minSecSwitch from "./components/minSecSwitch.vue";
import Radio from "./components/RadioInput.vue";
import Controls from "./components/Controls.vue";
import DateInput from "./components/DateInput.vue";
import TimeInput from "./components/TimeInput.vue";
import ProgressBar from "./components/ProgressBar.vue";
import Calculating from "./components/Calculating.vue";
import ResultsPage from "./components/ResultsPage.vue";
import axios from "axios";
import { required, between, minLength, email } from "vuelidate/lib/validators";

export default {
  name: "App",
  components: {
    radio: Radio,
    "text-input": SingleTextInput,
    "num-input": SingleNumericInput,
    step: Step,
    controls: Controls,
    "progress-bar": ProgressBar,
    "date-input": DateInput,
    "time-input": TimeInput,
    calculating: Calculating,
    results: ResultsPage,
    duration: SingleDuration,
    "app-switch": minSecSwitch,
  },

  data() {
    return {
      state: "form",
      // eslint-disable-next-line no-undef
      wpData: wpData,
      resultsData: null,
      currentIndex: 0,
      stepTransition: "fadeUp",
      appBackground: "#00000",
      showError: false,
      errorAnim: false,
      steps: {
        tv: ["genre", "country", "broadcaster", "dateTime", "tvDuration"],
        theatrical: ["country", "admissions", "durationStep"],
        "video-streaming": ["country", "vStreamPlatform", "streamsStep", "durationStep"],
        "music-streaming": ["country", "mStreamPlatform", "streamsStep", "masterOwned"],
      },
      userData: {
        locale: this.$i18n.locale,
        profile: "film-tv-producer",
        exploitation: "tv",
        country: "FR",
        genre: "serie",
        channel: "TF1",
        date: "",
        time: "21:00",
        programDuration: "",
        musicDuration: "",
        tvDurationInSeconds: false,
        admissions: "",
        totalDuration: "",
        controlledDuration: "",
        durationInSeconds: false,
        vStreamingPlatform: "Netflix",
        mStreamingPlatform: "Spotify",
        streams: "",
        masterOwned: "false",
        workTitle: "",
        clientName: "",
        clientEmail: "",
        nonce: "",
        action: "send_contact_form",
      },
      profile: [
        {
          name: "profile",
          label: this.$i18n.t('message.profile.filmTvProducer'),
          value: "film-tv-producer",
        },
        {
          name: "profile",
          label: this.$i18n.t('message.profile.composer'),
          value: "composer",
        },
        {
          name: "profile",
          label: this.$i18n.t('message.profile.musicPublisher'),
          value: "music-publisher",
        },
      ],
      exploitation: [
        {
          name: "exploitation",
          label: this.$i18n.t('message.exploitation.tv'),
          value: "tv",
        },
        {
          name: "exploitation",
          label: this.$i18n.t('message.exploitation.theatrical'),
          value: "theatrical",
        },
        {
          name: "exploitation",
          label: this.$i18n.t('message.exploitation.videoStreaming'),
          value: "video-streaming",
        },
        {
          name: "exploitation",
          label: this.$i18n.t('message.exploitation.musicStreaming'),
          value: "music-streaming",
        },
      ],
      genre: [
        {
          name: "genre",
          label: this.$i18n.t('message.genre.serie'),
          value: "serie",
        },
        {
          name: "genre",
          label: this.$i18n.t('message.genre.film'),
          value: "film",
        },
        {
          name: "genre",
          label: this.$i18n.t('message.genre.documentary'),
          value: "documentary",
        },
        {
          name: "genre",
          label: this.$i18n.t('message.genre.talkShow'),
          value: "talk-show",
        },
      ],
      masterOwned: [
        { name: "master", label: this.$i18n.t('message.master.no'), value: "false" },
        { name: "master", label: this.$i18n.t('message.master.yes'), value: "true" },
      ],
    };
  },

  computed: {
    currentStep() {
      return this.stepList[this.currentIndex];
    },
    stepList() {
      const list = ["profile", "exploitation"].concat(this.steps[this.userData.exploitation]);
      list.push("finalStep");
      return list;
    },
    apiData() {
      return JSON.parse(this.wpData.const);
    },
    tvChannels() {
      return this.apiData.tv.channels[this.userData.country];
    },
    workTitle() {
      if (this.userData.exploitation == "theatrical") {
        return this.$i18n.t('message.misc.film');
      } else if (this.userData.exploitation == "music-streaming") {
        return this.$i18n.t('message.misc.song');
      } else {
        return this.$i18n.t('message.misc.program');
      }
    },
    streamsTitle() {
      return this.userData.exploitation == 'music-streaming' ? this.$i18n.t('message.streams.musicStepTitle') : this.$i18n.t('message.streams.videoStepTitle');
    },
    clientName() {
      if (this.userData.profile == "composer") {
        return this.$i18n.t('message.lastStep.yourName');
      } else {
        return this.$i18n.t('message.lastStep.companyName');
      }
    },
    timeStamp() {
      return this.userData.durationInSeconds ? this.$i18n.t('message.misc.seconds') : this.$i18n.t('message.misc.minutes');
    },
    isMobile() {
      return window.matchMedia("only screen and (max-width: 760px)").matches;
    },
  },
  mounted() {
    window.addEventListener("keyup", (event) => {
      if (event.keyCode === 13 && this.state == "form") {
        if (this.currentStep == "finalStep") {
          this.calculate();
        } else {
          this.next();
        }
      }
    });
  },

  watch: {
    tvChannels: function() {
      this.userData.channel = this.tvChannels[0];
    },
  },

  methods: {
    back() {
      this.state = "switching";
      this.currentIndex--;
      this.stepTransition = "fadeDown";
    },

    next() {
      if (!this.validation()) return false;
      this.state = "switching";
      this.showError = false;
      this.currentIndex++;
      this.stepTransition = "fadeUp";
    },

    delayedNext() {
      setTimeout(() => this.next(), 300);
    },

    validation() {
      if (this.$refs[this.currentStep]) {
        let bool = false;
        this.$refs[this.currentStep].$children.forEach((element) => {
          if (element._props.valid && element._props.valid.$invalid) {
            bool = true;
          }
        });
        if (bool) {
          this.showError = true;
          this.errorAnim = true;
          setTimeout(() => (this.errorAnim = false), 1000);
          return false;
        }
      }
      return true;
    },

    calculate() {
      if (!this.validation()) return null;
      this.state = "calculating";
      this.appBackground = "#3fa9f5";
      this.userData.nonce = this.wpData.nonce;
      const vm = this;

      var data = new FormData();
      for (var key in this.userData) {
        data.append(key, this.userData[key]);
      }

      axios
        .post(this.wpData.ajax_url, data)
        .then(function(response) {
          vm.resultsData = JSON.parse(response.data.body);
          vm.state = "results";
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },

  validations() {
    return {
      userData: {
        date: {
          required,
        },
        time: {
          required,
        },
        admissions: {
          required,
          between: between(1, 1000000000),
        },
        programDuration: {
          required,
          between: between(1, 240),
        },
        musicDuration: {
          required,
          between: between(1, this.userData.tvDurationInSeconds ? Math.min(this.userData.programDuration * 60, 14400) : Math.min(Math.round(this.userData.programDuration), 240)),
        },
        totalDuration: {
          required,
          between: between(1, this.userData.durationInSeconds ? 14400 : 240),
        },
        controlledDuration: {
          required,
          between: between(1, this.userData.durationInSeconds ? Math.min(this.userData.totalDuration, 14400) : Math.min(Math.round(this.userData.totalDuration), 240)),
        },
        streams: {
          required,
          between: between(1, 1000000000),
        },
        workTitle: { required, minLength: minLength(2) },
        clientName: { required, minLength: minLength(2) },
        clientEmail: { required, email },
      },
    };
  },
};
</script>

<style lang="scss">
@import "./sass/app-style.scss";
</style>
